(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ln8lv", function(module, exports) {

var $kWqGi = parcelRequire("kWqGi");
const $f8f2384b7e2b53f9$var$localStorageNotificationHash = localStorage.getItem("notificationHash");
const $f8f2384b7e2b53f9$var$notifications = document.querySelectorAll(".i-notification");
$f8f2384b7e2b53f9$var$notifications.forEach((notification)=>{
    const notificationText = notification.querySelector(".i-alert__content")?.textContent;
    const notificationHash = notificationText ? String((0, $kWqGi.hashCode)(notificationText)) : null;
    if ($f8f2384b7e2b53f9$var$localStorageNotificationHash && notificationHash === $f8f2384b7e2b53f9$var$localStorageNotificationHash) {
        notification.remove();
        return;
    }
    const closeButtons = notification.querySelectorAll(".i-notification__close");
    closeButtons.forEach((closeButton)=>{
        closeButton.addEventListener("click", ()=>{
            notification.remove();
            notificationHash && localStorage.setItem("notificationHash", notificationHash);
        });
    });
});

});
parcelRegister("kWqGi", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $f3edebc483f39217$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "hashCode", function () { return $f3edebc483f39217$export$d41d9ab3de2def3d; });
function $f3edebc483f39217$export$6d4016d301bc6e21(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
        console.log("Error occurred while validating query:", e);
    }
    return false;
}
function $f3edebc483f39217$export$d70cf44bc3ae170(type, selector, callback, parent = document) {
    parent.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest(selector)) {
            const clickedElement = target.closest(selector);
            if (clickedElement) callback(clickedElement, event);
        }
    });
}
const $f3edebc483f39217$export$61fc7d43ac8f84b0 = (fn, delay = 500)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn.apply(undefined, args);
        }, delay);
    };
};
function $f3edebc483f39217$export$d41d9ab3de2def3d(str) {
    return str.split("").reduce((prevHash, currVal)=>(prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0, 0);
}

});


})();
//# sourceMappingURL=notification-item.2a845de8.js.map
